export const DELETE_UNDO_SECONDS = 15;

export function isTextInputTarget(target) {
    if (!(target instanceof HTMLElement)) return false;
    const tagName = target.tagName.toLowerCase();
    return target.isContentEditable || tagName === "input" || tagName === "textarea" || tagName === "select";
}

/**
 * Décide l'effet de la touche Entrée dans la liste :
 * null (rien, Entrée non consommée), "none" (consommée sans effet),
 * "edit" (ouvrir la commande sélectionnée) ou "select" (sélectionner la ligne focalisée).
 */
export function resolveEnterAction({ commandes, focusedIndex, selectedCommandeId, canEdit }) {
    const focused = focusedIndex >= 0 && focusedIndex < commandes.length ? commandes[focusedIndex] : null;
    const selected = commandes.find(commande => commande.id === selectedCommandeId);
    if (!focused && !selected) return null;

    if ((!focused || selectedCommandeId === focused.id) && selected && canEdit) {
        return { type: "edit", commande: selected };
    }
    if (focused) return { type: "select", commande: focused, index: focusedIndex };
    return { type: "none" };
}

export function mergeCommandeFlags(previous, commandes) {
    const next = {};
    commandes.forEach(cmd => {
        next[cmd.id] = {
            read:     previous[cmd.id]?.read     ?? cmd.read     ?? false,
            favorite: previous[cmd.id]?.favorite ?? cmd.favorite ?? false,
        };
    });
    return next;
}

export function tickPendingDelete(pending, id) {
    return pending.map(item =>
        item.cmd.id === id
            ? { ...item, secondsLeft: Math.max(0, item.secondsLeft - 1) }
            : item
    );
}

export function visibleCommandes(commandes, pendingDeletes) {
    const pendingIds = new Set(pendingDeletes.map(item => item.cmd.id));
    return commandes.filter(commande => !pendingIds.has(commande.id));
}

export function pageLabel(page, totalPages) {
    const pageCount = Math.max(totalPages, 1);
    return `Page ${Math.min(page + 1, pageCount)} / ${pageCount}`;
}

export function previousPage(currentPage) {
    return Math.max(0, currentPage - 1);
}

export function nextPage(totalPages) {
    return currentPage => Math.min(Math.max(totalPages - 1, 0), currentPage + 1);
}
